import React, { useState } from "react";
import { useFormik } from "formik";
import useFormHandlers from "../useFormHandlers";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { useStyles } from "../styles";
import * as Yup from "yup";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Grid,
  FormControlLabel,
  Switch,
  Tooltip
} from "@material-ui/core";

export const creditCardOnFileSchema = Yup.object().shape({
  chargeccbeforeopengate: Yup.bool()
});

const CreditCardOnFileSettingsForm = ({
  entityID,
  entityType,
  settingValues
}) => {
  const classes = useStyles();
  const [creditCardOnFileExpanded, setCreditCardOnFileExpanded] = useState(true);
  const toggleCreditCardOnFileExpanded = () => {
    setCreditCardOnFileExpanded(!creditCardOnFileExpanded);
  };

  const {
    values,
    setFieldValue,
    initialValues,
    errors
  } = useFormik({
    initialValues: {
      chargeccbeforeopengate: settingValues.chargeccbeforeopengate ?? false,
    },
    validationSchema: creditCardOnFileSchema
  });

  const {
    handleToggle
  } = useFormHandlers(setFieldValue, initialValues, entityID, entityType);

  return (
    <Grid
      container
      className={classes.panelRoot}
      data-testid="credit-card-on-file-panel"
    >
      <Accordion
        data-tag="creditCardOnFile"
        expanded={creditCardOnFileExpanded}
        TransitionProps={{
          unmountOnExit: true,
        }}
        className={classes.fullWidthAccordion}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          onClick={toggleCreditCardOnFileExpanded}
        >
          <Grid xs={12}>
            <Typography className={classes.heading}>
              Credit Card On File
            </Typography>
          </Grid>
        </AccordionSummary>
        <AccordionDetails>
          <Grid container spacing={3}>
            <Grid
              data-tag="chargeccbeforeopengate"
              item
              xs={12}
            >
              <Tooltip
                placement="top-end"
                title="Enable this to charge the access holder’s card before allowing them to exit. This feature might cause a slight increase in the amount of time a patron spends in the lane while their card is being processed."
              >
                <FormControlLabel
                  role="charge-cc-before-open-gate-toggle"
                  label="Charge Credit Card Before Opening Gate"
                  control={
                    <Switch
                      name="chargeccbeforeopengate"
                      color="primary"
                      onChange={e => handleToggle(values, errors, e)}
                      checked={values.chargeccbeforeopengate}
                      data-checked={values.chargeccbeforeopengate}
                      inputProps={{ 'aria-label': 'chargeCCBeforeOpenGate' }}
                    />}
                />
              </Tooltip>
            </Grid>
          </Grid>
        </AccordionDetails>
      </Accordion>
    </Grid>
  );
};

CreditCardOnFileSettingsForm.defaultProps = {
  settingValues: {},
};

export default CreditCardOnFileSettingsForm;